export const updateAnnouncement = `mutation updateAnnouncement($input: UpdateAnnouncementInput!) {
    updateAnnouncement(input: $input) {
    id
    companyId
    title
    content
    dateCreated
    hide
    userGroups
    thumbnail {
      bucket
      key
      region
    }
    displayGroupSelect
    tags
    pinned
    author
    thumbnailSignedUrl
    publishAt
    expireAt
    viewCount
    updatedAt
    }
  }
  `;
